import React, {
  ReactNode,
  useCallback,
  useMemo,
  // startTransition,
  // useEffect,
  useRef,
  // useState,
} from "react";
// import useBreakpoint from "../../Components/Grid/hooks/useBreakpoint";
import Typography from "../../Foundation/Typography/Typography";
import Icon, { IconProps } from "../../Foundation/Icon/Icon";
import { IDefaultTheme, useTheme } from "../../Themes/defaultTheme";
import {
  _NavigationMenuDiv,
  _NavigationMenuRoot,
} from "./NavigationMenu.styled";
import FlexBox from "../../Components/FlexBox/FlexBox";
import { clsx } from "clsx";
import Tag, { ITagProps } from "../../Components/Tag/Tag";
// import debounce from "lodash/debounce";

interface INavigationMenuProps {
  icon?: IconProps["icon"] | ((color: string) => ReactNode);
  iconColor?:
    | keyof IDefaultTheme["color"]
    | ((color: IDefaultTheme["color"]) => string);
  label?: ReactNode;
  onClick?: () => void;
  onFirstInteract?: () => void;
  iconTag?: ITagProps;
}

const NavigationMenu = (props: INavigationMenuProps) => {
  const { icon, iconColor, label, iconTag, onClick, onFirstInteract } = props;
  const { color } = useTheme();
  const [isInteractive, setIsInteractive] = React.useState(false);

  const onInteract = useMemo(() => {
    if (!isInteractive && onFirstInteract) {
      return () => {
        setIsInteractive(true);
        onFirstInteract();
      };
    }
    return;
  }, [isInteractive, onFirstInteract]);
  // const { isMobile } = useBreakpoint();
  // const [isClamped, setIsClamped] = useState(false);
  const textWrapperRef = useRef<HTMLSpanElement>(null);

  const iColor: string =
    typeof iconColor === "function" ? iconColor(color) : "white";

  const tagScale = iconTag?.children?.toString() === "0" ? 0 : 1;

  return (
    <_NavigationMenuDiv style={{ position: "relative" }}>
      <_NavigationMenuRoot
        className={clsx("navigation-menu", {
          // clamped: isClamped,
        })}
        as="span"
        align="center"
        onClick={onClick}
        onFocus={onInteract}
        onMouseEnter={onInteract}
        onTouchStart={onInteract}
      >
        <FlexBox
          gap={8}
          as={"span"}
          style={{
            // background: isClamped ? "transparent" : undefined,
            maxHeight: 24,
          }}
          ref={textWrapperRef}
        >
          {typeof icon === "function"
            ? icon(color.champagne)
            : icon && <Icon className="menu-icon" icon={icon} color={iColor} />}

          {label && (
            <Typography
              variant="h7"
              color="white"
              className={clsx("navigation-menu__label", "d-desktop")}
              as={"span"}
              data-cs-mask
            >
              {label}
            </Typography>
          )}
        </FlexBox>
      </_NavigationMenuRoot>
      {iconTag && (
        <div
          style={{
            position: "absolute",
            left: 12,
            top: -12,
            transition: "transform 0.5s ease",
            transform: `scale(${tagScale})`,
          }}
          onClick={onClick}
          className="d-mobile"
        >
          <Tag
            {...iconTag}
            style={{
              background: color.champagne,
              padding: 2,
              width: 24,
              height: 24,
            }}
          />
        </div>
      )}
    </_NavigationMenuDiv>
  );
};

export default NavigationMenu;
